import { ActionIcon, Box, Button, Grid, Group, Loader, Modal, Paper, Table, Text, Title, Tooltip, UnstyledButton } from '@mantine/core';
import React, { useRef } from 'react';
import { FaChartLine, FaCheck, FaCheckCircle, FaExclamationCircle, FaPlus } from 'react-icons/fa';
import SimpleHeader from '../components/simple_header';
import { useAuth } from '../contexts/auth.context';
import { useLocation, useNavigate } from 'react-router-dom';
import VehicleTraject from '../components/reports/vehicle_traject';
import Devices from '../components/reports/devices';
import Trajects from '../components/reports/trajects';
import VehicleTrajectView from '../components/reports/vehicle_traject_view';
import { GET_REPORTS, GET_REPORT_DETAILS } from '../services/reports';
import { showNotification } from '@mantine/notifications';
import { useApp } from '../contexts/app.context';
import { getExtenseDatetime } from '../utility/util';
import InputField, { InputFieldTypes } from '../components/input_field';
import moment from 'moment';
import ReactToPrint from 'react-to-print';
// import { Channels, Flows } from '../components';

export default function SettingsPage(){
    const [selected, setSelected] = React.useState("vehicle-traject");
    const [reports, setReports] = React.useState([]);
    const [openReport, setOpenReport] = React.useState<any>(null);
    const [loadingReport, setLoadingReport] = React.useState<boolean>(false);
    const [openReportData, setOpenReportData] = React.useState<any>(null);
    const [period, setPeriod] = React.useState([
        moment().startOf("week").toDate(),
        moment().startOf("day").toDate(),
    ]);

    const { hash } = useLocation();
    const { currentCompany } = useAuth();
    const { socket } = useApp();
    const navigate = useNavigate();

    const printRef = useRef<any>();

    const options = [
        {key: "vehicle-traject", title: "Veículo x Intervalo", buttons: []},
        {key: "travels", title: "Deslocamentos", buttons: []},
        {key: "devices", title: "Registros", buttons: []},
    ].filter(nn => nn)

    const loadReports = () => {
        GET_REPORTS()
        .then((res) => {
            setReports(res)
        })
        .catch(err => {
            showNotification({ message: err.message, color: 'red' })
        })
    }
    
    const loadReportDetails = () => {
        if(openReport){
            setLoadingReport(true)
            GET_REPORT_DETAILS(openReport._id)
            .then((res) => {
                setLoadingReport(false)
                setOpenReportData(res)
            })
            .catch(err => {
                setLoadingReport(false)
                showNotification({ message: err.message, color: 'red' })
            })
        }
    }

    React.useEffect(() => {
        loadReports();
    }, []);
    
    React.useEffect(() => {
        loadReportDetails();
    }, [openReport]);

    React.useEffect(() => {
        if(socket && currentCompany?.company?._id){
            const cb = (report) => {
                loadReports();
                if(!report.error) setOpenReport(r => r ? r : report);
            }
            socket.on(`report-updated-${currentCompany?.company?._id}`, ({ report }) => { cb(report) })
            return () => {
                socket.off(`report-updated-${currentCompany?.company?._id}`, ({ report }) => { cb(report) })
            }
        }
    }, [socket, currentCompany]);
    
    React.useEffect(() => {
        if (hash) {
            setSelected(hash.split("#")[1]);
        };
    }, [hash]);

    return <>
        <Grid>
            <Grid.Col xs={12} md={12}>
                <SimpleHeader
                    Icon={FaChartLine}
                    title={`Relatórios - ${options.find(opt => opt.key === selected)?.title}`}
                    buttons={options.find(opt => opt.key === selected)?.buttons}
                />

                <Paper p="md" shadow='xs' mt="md">
                    <Grid>
                        {options.map(({key, title}) => <Grid.Col md={3}>
                            <Button key={key} onClick={() => navigate(`/relatorios#${key}`)} fullWidth variant={selected === key ? "filled" : "light"}>
                                {title}
                            </Button>
                        </Grid.Col>)}
                    </Grid>
                </Paper>
            </Grid.Col>
            <Grid.Col xs={12} md={selected === "vehicle-traject" ? 9 : 12}>
                <Paper p="md" shadow='xs'>
                    {selected === "vehicle-traject" && <VehicleTraject onGenerate={loadReports} />}
                    {selected === "devices" && <Devices onGenerate={loadReports} />}
                    {selected === "travels" && <Trajects onGenerate={loadReports} />}
                </Paper>
            </Grid.Col>

            {selected === "vehicle-traject" && <Grid.Col xs={12} md={3}>
                <Paper p="md" shadow='xs'>
                    <InputField
                        name="p"
                        value={period}
                        onChange={({p}) => setPeriod(p)}
                        fieldType={InputFieldTypes.DATERANGE}
                    />
                    {reports
                        .sort((a,b) => a.createdAt > b.createdAt ? -1 : 1)
                        .filter(r => moment(r.createdAt).isBetween(moment(period[0]).startOf("day"), moment(period[1]).endOf("day")))
                        .map(r => <UnstyledButton
                            mt="md"
                            onClick={() => { if(!r.error) setOpenReport(r); }}
                            style={{width: '100%'}}>
                                <Paper style={{flex: 1, border: '1px solid #DFDFDF'}} p="md" pl="md">
                                    <Group>
                                        <Box style={{flex: 1}}>
                                            <Text size="md" c="orange">{r.type === "vehicle-traject" ? "Veículo x Intervalo" : "Relatório"}</Text>
                                            <Text size="xs">{getExtenseDatetime(r.createdAt)}</Text>
                                        </Box>
                                        {
                                            r.error
                                            ? <Tooltip label={r.error}>
                                                <ActionIcon size="xl" variant='filled' color="red">
                                                    <FaExclamationCircle />
                                                </ActionIcon>
                                            </Tooltip>
                                            : !(r.loading)
                                                ? <ActionIcon size="xl" variant='filled' color="orange"><FaCheckCircle /></ActionIcon>
                                                : <ActionIcon size="xl" variant='filled' color="gray">
                                                    <Loader color="white" size="sm" />
                                                </ActionIcon>
                                        }
                                    </Group>
                                </Paper>
                        </UnstyledButton>)}
                </Paper>
            </Grid.Col>}
        </Grid>

        <Modal
            opened={!!openReport}
            onClose={() => setOpenReport(null)}
            size="100vw"
        >
            {loadingReport ? <Loader size="lg" />
            : <>
                <ReactToPrint
                    trigger={() => {
                        return <Button variant='outline' size="md" mt="md">Imprimir</Button>;
                    }}
                    content={() => printRef.current}
                />
                {openReport && <div style={{ background: '#FFFFFF'}}>
                    <div ref={printRef} style={{}}>
                        { openReport.type === "vehicle-traject" && <VehicleTrajectView data={openReportData} /> }
                    </div>
                </div>}
            </>}
        </Modal>

    </>
    
}
